import { ensureSiAdmin, post, useTranslate } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';
import { useUser } from './useUser';

interface Params {
  inviteId: string;
}

export function useResendInvite() {
  const queryClient = useQueryClient();
  const { user } = useUser();
  const { t, translate } = useTranslate();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ inviteId }: Params) => {
      ensureSiAdmin(user, translate(t.adminAccessRequired));
      return post({
        url: `/api/admin/invites/${inviteId}/resend`,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getInvites,
      });
    },
  });

  const resendInvite = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    resendInvite,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
